module.exports = __webpack_public_path__ + "img/frame (90).fad79679.jpg";